import { FormikProps } from 'formik';
import { Media, UploadState, UploadType } from '@synergy/models';
import { PoolDropzone, PoolFileList, PoolTypography } from '@synergy/components';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { BankAccountFormValues } from '../../models/bank-account-form-values';
import { useAppSelector } from '../../../../store/use-appstate-selector';

const useStyles = makeStyles((theme: Theme) => ({
    dropzone: {
        marginBottom: theme.spacing(2),
    },
}));

interface BankAccountsDocumentsProps {
    form: FormikProps<BankAccountFormValues>;
}

export const BankAccountsDocuments = (props: BankAccountsDocumentsProps) => {
    const { form } = props;
    const classes = useStyles();
    const privateFilesystemPath = useAppSelector(state => state.settings.privateFilesystemPath);
    const formMedia = form.values.media;

    const handleFileDrop = (acceptedFiles: File[]) => {
        const existingMedia = formMedia;

        const deduplicated = acceptedFiles.filter(
            acceptedFile =>
                !existingMedia.some(
                    media => media.originalName === acceptedFile.name && media.size === acceptedFile.size
                )
        );

        const newMedia = deduplicated.map(file => Media.fromFile(file, UploadType.Internal));
        newMedia.forEach(media => (media.state = UploadState.Finished));
        form.setFieldValue('media', existingMedia.concat(newMedia));
    };

    const handleFileRemove = (media: Media) => {
        form.setFieldValue(
            'media',
            formMedia.filter(m => m !== media)
        );
    };

    return (
        <>
            <PoolTypography styleType="sectionTitle" id="app.common.dropDocument" />
            <PoolDropzone onDrop={handleFileDrop} className={formMedia.length > 0 ? classes.dropzone : ''} />
            <PoolFileList
                acceptedFiles={formMedia}
                onDeleteClicked={handleFileRemove}
                downloadBaseUrl={privateFilesystemPath}
                directDownload={false}
            />
        </>
    );
};
